
import { Milestone } from "@/model/Project";
import { defineComponent } from "@vue/runtime-core";
import { PropType } from "vue";
import Slider from "./Slider.vue";

export default defineComponent({
  components: { Slider },
  props: {
    value: Object as PropType<Milestone>,
  },
  data: function () {
    return {
      total: 100,
    };
  },
  computed: {
    process() {
      if (this.value.length <= 1) return this.total;
      let stepSize = this.total;
      if (this.value.length > 2) {
        stepSize = this.total / (this.value.length - 1);
      }

      let process = 0;
      let i = 0;
      const now = Date.now();
      console.log(stepSize);
      while (i < this.value.length && this.value[i].releaseDate < now) {
        console.log(this.value[i].releaseDate);
        process += stepSize;
        i++;
      }

      if (i < 1) process = 0;
      else if (i >= this.value.length - 1) process = this.total;
      else {
        console.log(this.value[i], this.value[i - 1], i);
        console.log(this.value[i].releaseDate, this.value[i - 1].releaseDate);

        let span = this.value[i].releaseDate - this.value[i - 1].releaseDate;
        let relative = now - this.value[i - 1].releaseDate;

        console.log((relative / span) * stepSize);
        process = (i - 1) * stepSize + (relative / span) * stepSize;
      }

      return process;
    },
  },
  methods: {
    isMilestoneCompleted(milestone) {
      return milestone.releaseDate - Date.now() <= 0;
    },
  },
});
